import { applyOpenBetsRPCQueries, OpenBetsQueryBuilder } from "./Helpers";
export class OpenBetsRPCConnection {
    constructor(meta) {
        this.meta = meta;
    }
    acceptNewOffer(params) {
        return applyOpenBetsRPCQueries(OpenBetsQueryBuilder.acceptNewOffer(params), this.meta);
    }
    declineNewOffer(params) {
        return applyOpenBetsRPCQueries(OpenBetsQueryBuilder.declineNewOffer(params), this.meta);
    }
    cashOutBet(params) {
        return applyOpenBetsRPCQueries(OpenBetsQueryBuilder.cashOutBet(params), this.meta);
    }
}
//# sourceMappingURL=OpenBetsRPCConnection.js.map